module.exports = __webpack_public_path__ + "media/src/images/icon/event-707060e7ad8db2166cf6693caa1d2b91.png";